import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=1fc9ef29&scoped=true&"
import script from "./BoardList.vue?vue&type=script&lang=js&"
export * from "./BoardList.vue?vue&type=script&lang=js&"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=1fc9ef29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc9ef29",
  null
  
)

export default component.exports